import { useEffect } from 'react';

/**
 * @param {HTMLElement} obj
 * @param {number} start
 * @param {number} end
 * @param {number} duration
 * @param {string} lang
 * @returns {void}
 */
const animateValue = (obj, start, end, duration, lang) => {
  let startTimestamp = null;
  const step = (timestamp) => {
    if (!startTimestamp) startTimestamp = timestamp;
    const progress = Math.min((timestamp - startTimestamp) / duration, 1);

    obj.innerHTML = String(
      Intl.NumberFormat(lang).format(
        Math.floor(progress * (end - start) + start),
      ),
    );
    if (progress < 1) {
      window.requestAnimationFrame(step);
    }
  };
  window.requestAnimationFrame(step);
};

/**
 * @param {string} number
 * @param {string} lang
 * @returns {string | 0}
 */
const formatNumberForLocale = (number, lang) => {
  const onlyNumbers = /[^0-9]/gi;
  return (
    new Intl.NumberFormat(lang)
      .format(Number(number || 0))
      .replace(onlyNumbers, '') || 0
  );
};

/**
 * @param {Object} props
 * @param {number} props.count
 * @param {string} props.domID
 * @param {string} props.lang
 * @param {ReactElement} props.children
 * @returns {ReactElement}
 */
const AnimatedCount = ({ count, domID, lang, children }) => {
  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    // This is done to have a separator on the numbers with one thousand digit is Spanisn (ex. 4.500)
    // The Intl.NumberFormat only adds the separator if the number has more than 2 thousand digits in Spanish
    const langToFormat = lang === 'es' ? 'de' : lang;
    const obj = document.getElementById(domID);
    const countOnDom = formatNumberForLocale(
      obj?.innerText || '',
      langToFormat,
    );
    const timeoutID = setTimeout(() => {
      if (obj && count > 0 && count !== Number(countOnDom)) {
        animateValue(obj, Number(countOnDom), count, 500, langToFormat);
      }
    }, 0);
    return () => clearTimeout(timeoutID);
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */

  return <>{children}</>;
};

export default AnimatedCount;
